import BASE_RULE from '../baseRule';
import {SearchTypeExpiration} from './constants';
import {ExpirationRule} from './types';

export const expirationRuleDefaults: ExpirationRule = {
	...BASE_RULE,
	elementType: SearchTypeExpiration,
	elementSubType1: 0,
};

export default expirationRuleDefaults;
